export default __webpack_public_path__ + "static/O0221-c764524aeaa55621728b1386333ada16.png";